import React, { useState } from 'react';
import { playThemeSound } from '../../../utils/themeAudio';

const RangoliMandala = () => {
    const [petalsBurst, setPetalsBurst] = useState(false);

    const handleRangoliClick = () => {
        playThemeSound('diwali', 'sparkle');
        setPetalsBurst(true);
        setTimeout(() => setPetalsBurst(false), 2400);
    };

    return (
        <div className="fixed inset-0 pointer-events-none z-[61] overflow-hidden select-none">
            {/* Shower of Floating Marigold Petals on Click */}
            {petalsBurst && (
                <div className="fixed inset-0 pointer-events-none z-[74] overflow-hidden">
                    {Array.from({ length: 28 }).map((_, i) => (
                        <div
                            key={i}
                            className="absolute bottom-10 animate-float-up text-lg select-none"
                            style={{
                                left: `${10 + Math.random() * 80}%`,
                                animationDuration: `${2.2 + Math.random() * 2}s`,
                                animationDelay: `${Math.random() * 0.4}s`,
                            }}
                        >
                            {['🌼', '🌸', '🪙', '🪷', '✨'][i % 5]}
                        </div>
                    ))}
                </div>
            )}

            {/* Glowing Sacred Rangoli in Bottom-Right Corner */}
            <div
                onClick={handleRangoliClick}
                className="absolute -bottom-16 -right-16 w-48 h-48 md:w-64 md:h-64 pointer-events-auto cursor-pointer hover:scale-110 transition-transform duration-500 opacity-80 hover:opacity-100"
                title="Sacred Rangoli Mandala - Click for marigold blessings! 🪷"
            >
                <svg viewBox="0 0 200 200" className="w-full h-full animate-spin-slow drop-shadow-[0_0_16px_rgba(245,158,11,0.6)]">
                    {/* Outer Ring of Petals */}
                    {Array.from({ length: 12 }).map((_, i) => {
                        const angle = i * 30;
                        return (
                            <ellipse
                                key={i}
                                cx="100"
                                cy="30"
                                rx="10"
                                ry="24"
                                fill={i % 2 === 0 ? '#f59e0b' : '#e11d48'}
                                opacity="0.85"
                                transform={`rotate(${angle} 100 100)`}
                            />
                        );
                    })}

                    {/* Middle Ring of Cyan & Gold Dots */}
                    {Array.from({ length: 16 }).map((_, i) => {
                        const angle = i * 22.5;
                        return (
                            <circle
                                key={i}
                                cx="100"
                                cy="55"
                                r="4"
                                fill={i % 2 === 0 ? '#06b6d4' : '#fde047'}
                                transform={`rotate(${angle} 100 100)`}
                            />
                        );
                    })}

                    {/* Inner Sacred Lotus Petals */}
                    {Array.from({ length: 8 }).map((_, i) => {
                        const angle = i * 45;
                        return (
                            <path
                                key={i}
                                d="M 100 68 C 92 82 92 92 100 100 C 108 92 108 82 100 68 Z"
                                fill="#a855f7"
                                opacity="0.9"
                                transform={`rotate(${angle} 100 100)`}
                            />
                        );
                    })}

                    {/* Golden Center Bindu Diya */}
                    <circle cx="100" cy="100" r="16" fill="#fbbf24" stroke="#d97706" strokeWidth="2" />
                    <circle cx="100" cy="100" r="8" fill="#ffffff" className="animate-pulse" />
                </svg>
            </div>
        </div>
    );
};

export default RangoliMandala;
